export default "__VITE_ASSET__vqPn9e$$__"